import { useQuery } from "@tanstack/react-query";

import { fetchProfileData, getHouseholdRelationships } from "./fetch";
import { userProfileKeys } from "./keys";

export const useFetchProfileData = ({ userID, enabled, staleTime = 5000 }) => {
  return useQuery({
    queryKey: userProfileKeys.user(userID),
    queryFn: () => fetchProfileData(userID),
    enabled: Boolean(userID) && enabled,
    staleTime,
    retry: isNaN(userID) ? false : 3,
  });
};

export const useGetHouseholdRelationships = ({ userID }) => {
  return useQuery({
    queryKey: userProfileKeys.householdRelationships(userID),
    queryFn: () => getHouseholdRelationships({ userID }),
    enabled: Boolean(userID),
  });
};
